// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const scizor: PokeData = {
  "id": 212,
  "name": "scizor",
  "height": 18,
  "weight": 1180,
  "base_experience": 175,
  "types": [
    PokeType.BUG,
    PokeType.STEEL
  ],
  "api_moves": [
    "razor-wind",
    "swords-dance",
    "wing-attack",
    "leer",
    "agility",
    "quick-attack",
    "double-team",
    "focus-energy",
    "slash",
    "false-swipe",
    "fury-cutter",
    "pursuit",
    "metal-claw",
    "silver-wind",
    "aerial-ace",
    "iron-defense",
    "feint",
    "close-combat",
    "night-slash",
    "air-slash",
    "x-scissor",
    "bullet-punch",
    "iron-head",
    "double-hit",
    "laser-focus"
  ],
  "moves": [
    "leer",
    "quick-attack",
    "pursuit",
    "metal-claw",
    "aerial-ace",
    "close-combat",
    "night-slash",
    "air-slash",
    "heal-order",
    "scrap-throw",
    "metal-sound",
    "lunge",
    "leech-steal"
  ],
  "evolution_chain": {
    "id": 58,
    "item": null,
    "species": [
      {
        "name": "scyther",
        "order": 141,
        "types": [
          PokeType.BUG,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "scizor",
        "order": 142,
        "types": [
          PokeType.BUG,
          PokeType.STEEL
        ],
        "evolves_from_species_id": 123,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      },
      {
        "name": "kleavor",
        "order": 900,
        "types": [
          PokeType.BUG,
          PokeType.ROCK
        ],
        "evolves_from_species_id": 123,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "black-augurite"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 116,
    "speed": 95,
    "ability_power": 189
  },
  "stat_changes": [],
  "catch_rate": 25,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
